/* eslint-disable no-restricted-syntax */
import './BarChartReport.css';
import { BarChart, d3 } from 'react-d3-components';
import { t } from 'i18next';
import { connect } from 'react-redux';
import React from 'react';
import { stringToNumberLocale } from '../../../helpers/formatter';
import ChartReport from '../ChartReport';
import ColorDetails from '../colorDetails/ColorDetails';
import ReportsDescription from '../reportsDescription/ReportsDescription';


const maxTicksLength = 16;

class BarChartReport extends ChartReport {
  render() {
    const {
      data, description = null, grouped = false,
      height, helperMsg = '',
      inputRequired = false, isMeteringPage,
      title, width,
      xLabel = '', yLabel = '',
    } = this.props;

    const descExpanded = description ? description.isExpanded : false;
    return (
      <div id={title}
        className="BarChartReport report"
        style={{
          width,
        }}
      >
        <ReportsDescription descriptionObj={description}
          id={title}
          isMeteringPage={isMeteringPage}
          title={t(title)}
          width={width - (width * 0.05)}
        />

        { inputRequired && data && (data !== t('unableToFetchData'))

          ? ChartReport.helperMsg(width, height, helperMsg, descExpanded)

          : (
            <span>
              {! data || data === t('unableToFetchData')

                ? ChartReport.chartStatus(width, height, data)

                : (

                  <BarChart groupedBars={grouped}
                    data={data && data.length > 0 && data[0].values.length ? data : {
                      values: [{
                        x: '',
                        y: 0,
                      }],
                    }}
                    width={width}
                    height={height}
                    margin={ChartReport.chartMargin()}
                    colorScale={d3.scale.category20()}
                    tooltipHtml={(x, _, y) => `${x}: ${stringToNumberLocale(y)}`}
                    xAxis={ChartReport.xAxis(xLabel)}
                    yAxis={ChartReport.yAxis(yLabel)}
                  />
                )
      }

              {ChartReport.tooltipContainer(title)}

              { data && data.length === 0
                ? <span className="noData">{t('N/A')}</span> : '' }

              {! this.props.data || this.props.data === t('unableToFetchData') || this.props.data.length < 2 || ! this.props.data[0].values.length
                ? null
                : (
                  <ColorDetails data={this.props.data.map(({ label, values }, index) => ({
                    color: d3.scale.category20().range()[index],
                    label,
                    values,
                  }))}
                  />
                )
      }
            </span>
          )
    }
      { t(title) === t('devices.hostSoftwareVersionOverTime')
        ? <p>{ t('devices.hostSoftwareVersionOverTimeDataAvailable') }</p>
        : null }
      </div>
    );
  }

  componentDidUpdate() {
    const { title } = this.props;
    for (const rect of [...document.getElementById(title).getElementsByClassName('bar')]) {
      const computedBarHeight = parseFloat(rect.getAttribute('height'));
      const computedYpos = parseFloat(rect.getAttribute('y'));
      const minOffset = 2;

      if (computedBarHeight > 0 && computedBarHeight < minOffset) {
        rect.setAttribute('height', computedBarHeight + minOffset);
        rect.setAttribute('y', computedYpos - minOffset);
      }
    }

    // get x axis tick textSVG array
    // replace with empty string till skip values
    const textSVGs = document.getElementById(title).querySelectorAll('.x.axis .tick text');

    if (textSVGs.length > maxTicksLength) {
      // calculate values to skip
      const skipValues = (Math.ceil(textSVGs.length / maxTicksLength));
      textSVGs.forEach((textSVG, i) => {
        // eslint-disable-next-line no-param-reassign
        if (i % skipValues !== 0) textSVG.innerHTML = '';
      });
    }


    this.generateTooltips();
  }
}

export default connect()(BarChartReport);
